import {MuWidget} from "mu-widget/lib/MuWidget";
import {t} from "../translate";
import {formatEnergy, formatWeight} from "../utils";

export class UiComponentPreview extends MuWidget {
    beforeIndex() {
        this.container.classList.add('component-preview');
        this.muAppendContent(`
            <span mu=":.@item">
                <em mu="#label"></em>
                <span mu="#value"></span>
            </span>
        `);
    }

    private static readonly keyOrder = ['energy', 'protein', 'carbohydrate', 'fatSat', 'fatUnsat'];

    muBindData(srcData: Record<string, number>|null) {
        if (srcData === null) return;
        this.container.innerHTML = '';
        const keys = Object.keys(srcData).sort((a, b) => {
            const ai = UiComponentPreview.keyOrder.indexOf(a);
            const bi = UiComponentPreview.keyOrder.indexOf(b);
            return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
        });
        for(const k of keys) {
            let value;
            let tk;
            if (k === 'energy') {
                value = formatEnergy(srcData[k]);
                tk = 'energy';
            } else {
                value = formatWeight(srcData[k]);
                tk = k + 'Content';
            }
            this.muWidgetFromTemplate('item', this.container)
                .muBindData({
                    label: t(tk as any),
                    value,
                });
        }
    }
}